import type { Locale } from "@/shared/utils";

function getLocaleString(locale?: Locale): string {
  if (!locale) return "ru-RU";
  const localeMap: Record<Locale, string> = {
    ru: "ru-RU",
    kk: "kk-KZ",
    en: "en-US",
  };
  return localeMap[locale] || "ru-RU";
}

export function formatPercentageFromRate(rate: number): string {
  const percentage = rate * 100;
  const rounded = parseFloat(percentage.toPrecision(10));
  return `${rounded}%`;
}

export function formatPercentage(value: string | number, locale?: Locale): string {
  const num = typeof value === "string" ? parseFloat(value) : value;
  const localeString = getLocaleString(locale);
  const formatter = new Intl.NumberFormat(localeString, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${formatter.format(num)}%`;
}

